export default "__VITE_ASSET__C$8m43aO__"